import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { changeAccountStateRequest } from "../../services/APIService";
import { CLIENT_ID } from "../../config/Config"; // <--- Import aus Config.js

export interface PayPageState {
  show: boolean;
  success: boolean;
  errorMessage: string;
  orderID: string | false;
  clientId: string; // <--- Im State hinzugefügt
}

export const usePayPageVM = (tag: string) => {
  const navigate = useNavigate();
  const endOfSide = useRef<HTMLDivElement | null>(null);

  const [show, setShow] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [orderID, setOrderID] = useState<string | false>(false);

  const changeAccountState = async (userTag: string) => {
    try {
      await changeAccountStateRequest(userTag);
      console.log("Erfolgreich gesendet");
      navigate("/MainPage");
    } catch (error) {
      console.error("Fehler beim Senden:", error);
    }
  };

  const scrollToBottom = () => {
    endOfSide.current?.lastElementChild?.scrollIntoView();
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setShow(event.target.checked);
    scrollToBottom();
  };

  const createOrder = (data: any, actions: any) => {
    return actions.order
      .create({
        purchase_units: [
          {
            description: "Junior Alarm Monatsabo",
            amount: {
              currency_code: "EUR",
              value: 20.0,
            },
          },
        ],
      })
      .then((id: string) => {
        setOrderID(id);
        return id;
      });
  };

  const onApprove = (data: any, actions: any) => {
    return actions.order.capture().then(() => {
      setSuccess(true);
      changeAccountState(tag);
    });
  };

 const onError = (err: any) => {
  console.error("PayPal Error:", err);
  setErrorMessage("An Error occured with your payment");
};

  useEffect(() => {
    if (success) {
      console.log("Order successful. Your order id is--", orderID);
    }
  }, [success, orderID]);

  return {
    state: {
      show,
      success,
      errorMessage,
      orderID,
      clientId: CLIENT_ID, // <--- Weitergabe an die View
    },
    actions: {
      handleCheckboxChange,
      createOrder,
      onApprove,
      onError,
    },
    refs: {
      endOfSide,
    },
  };
};